/* eslint-disable */
import React, { useState } from "react";
import "contents/assets/scss/page/statistics.scss";
import Tab from "../../component/Inc/Tab";
import LineChart from "../../component/Inc/LineChart";
import Calendar from "../../component/Inc/Calendar";

const SalesBookDetail = () => {
  const lineChartWidth = "100%";
  const lineChartHeight = "200px";

  const [modalOpen, setModalOpen] = useState(false);
  //Tab Component
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    { title: "전체", value: 0 },
    { title: "발송", value: 1 },
    { title: "반품", value: 2 },
  ];

  //Linechartlabels
  const lineChartlabels = [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월",
  ];

  //SalesBook detail line chart data
  const lineChartDataSalesBookDetail = {
    lineChartlabels,
    datasets: [
      {
        label: "발송",
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: "#d1cdca",
        borderWidth: 1,
        backgroundColor: "#fc8019",
      },
      {
        label: "반품",
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: "#d1cdca",
        borderWidth: 1,
        backgroundColor: "#3780ff",
      },
    ],
  };
  return (
    <main className="com_container p_salesBook_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu10_9 ">
            총판 매출 통계
            <span className="bar" />
            <span className="point_txt">
              서울 제일총판 (공급가 : 50%ㆍ채택가 : 40%)
            </span>
          </h2>
          <button
            onClick={() => setModalOpen(true)}
            className="com_btn orange s btn_plus"
          >
            총판 관리
          </button>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />

              <section className="com_board_search">
                <article className="search">
                  <input
                    type="search"
                    placeholder="검색할 내용을 입력해 주세요."
                    className="input s type_search"
                  />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>

            <hr className="com_divider" />
            <div className="com_calendar_wrap">
              <Calendar />
            </div>
            <table className="com_board_list ">
              <colgroup>
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
              </colgroup>
              <thead>
                <tr>
                  <th>총 발송 권 수</th>
                  <th>총 발송 금액</th>
                  <th>
                    <button className="arrow active" />
                    발송 권 수
                  </th>
                  <th>
                    <button className="arrow active" />총 반품 금액
                  </th>
                  <th>실 매출액</th>
                  <th>실 입금액</th>
                  <th>잔액</th>
                  <th>조정 금액</th>
                  <th>현 잔액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>45</td>
                  <td className="td_red">78,450,000</td>
                  <td>20</td>
                  <td className="td_red">- 350,000</td>
                  <td className="td_point">450,000</td>
                  <td>450,000</td>
                  <td>310,000</td>
                  <td className="td_point td_width">
                    645,000
                    <button className="btn_edit" />
                  </td>
                  <td className="td_red">450,000</td>
                </tr>
              </tbody>
            </table>
            <table className="com_board_list ">
              <colgroup>
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
                <col width="{{ width: 'calc(100% / 9)' }}" />
              </colgroup>
              <thead>
                <tr>
                  <th>NO</th>
                  <th>비고</th>
                  <th>
                    <button className="arrow active" />
                    발송, 반품일
                  </th>
                  <th>
                    <button className="arrow active" />
                    발송자
                  </th>
                  <th>
                    <button className="arrow active" />
                    교재 명
                  </th>
                  <th>
                    <button className="arrow active" />
                    발송, 반품 권 수
                  </th>
                  <th>판매가</th>
                  <th>공급가</th>
                  <th>채택가</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>발송</td>
                  <td>2023, 05, 12</td>
                  <td>김발송103</td>
                  <td>13221 과학{3} 즐거운 과학</td>
                  <td>20</td>
                  <td>10,000</td>
                  <td className="td_point">5,000</td>
                  <td></td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>발송</td>
                  <td>2023, 05, 12</td>
                  <td>김발송103</td>
                  <td>13221 과학{3} 즐거운 과학</td>
                  <td>20</td>
                  <td>10,000</td>
                  <td className="td_point">5,000</td>
                  <td className="td_point">8,000</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td className="td_red">발송</td>
                  <td>2023, 05, 12</td>
                  <td>김발송103</td>
                  <td>13221 과학{3} 즐거운 과학</td>
                  <td>20</td>
                  <td>10,000</td>
                  <td className="td_red">-103,000</td>
                  <td></td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>발송</td>
                  <td>2023, 05, 12</td>
                  <td>김발송103</td>
                  <td>13221 과학{3} 즐거운 과학</td>
                  <td>20</td>
                  <td>10,000</td>
                  <td className="td_point">5,000</td>
                  <td className="td_point">4,000</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>발송</td>
                  <td>2023, 05, 12</td>
                  <td>김발송103</td>
                  <td>13221 과학{3} 즐거운 과학</td>
                  <td>20</td>
                  <td>10,000</td>
                  <td className="td_point">5,000</td>
                  <td></td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>발송</td>
                  <td>2023, 05, 12</td>
                  <td>김발송103</td>
                  <td>13221 과학{3} 즐거운 과학</td>
                  <td>20</td>
                  <td>10,000</td>
                  <td className="td_point">5,000</td>
                  <td></td>
                </tr>
                <tr className="summarized_rows">
                  <td colSpan="2">2023</td>
                  <td></td>
                  <td></td>
                  <td className="td_point">42종</td>
                  <td className="td_point">547,000</td>
                  <td className="td_point">547,000</td>
                  <td className="td_point">547,000</td>
                  <td className="td_point">547,000</td>
                </tr>
                <tr className="summarized_rows">
                  <td colSpan="2">2022</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>547,000</td>
                  <td>547,000</td>
                  <td>547,000</td>
                  <td>547,000</td>
                </tr>

                <tr className="summarized_rows">
                  <td colSpan="2">증감율</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="td_point">
                    <span className="arrow_blue down">654</span>
                  </td>
                  <td className="td_point">
                    <span className="arrow_blue down">654</span>
                  </td>
                  <td className="td_point">
                    <span className="arrow_blue down">654</span>
                  </td>
                  <td className="td_point">
                    <span className="arrow_blue down">654</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="com_btn_wrap right">
              <button className="com_btn black xs btn_down_orange">
                다운로드
              </button>
            </div>
            <hr className="com_divider" />
            <div className="detail_tit dot">조정금액 목록</div>
            <table className="com_board_list ">
              <colgroup>
                <col width="{{ width: 'calc(100% / 5)' }}" />
                <col width="{{ width: 'calc(100% / 5)' }}" />
                <col width="{{ width: 'calc(100% / 5)' }}" />
                <col width="{{ width: 'calc(100% / 5)' }}" />
                <col width="{{ width: 'calc(100% / 5)' }}" />
              </colgroup>
              <thead>
                <tr>
                  <th className="arrow ">총 발송 권 수조정일</th>
                  <th>조정자총 발송 금액</th>
                  <th>잔액</th>
                  <th>조정 금액</th>
                  <th>사유</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2023, 05, 10</td>
                  <td>김관리103</td>
                  <td>450,000</td>
                  <td className="td_point">+ 40,000</td>
                  <td>반품처리 하지 않고 금액만 반품</td>
                </tr>
                <tr>
                  <td>2023, 05, 10</td>
                  <td>김관리103</td>
                  <td>450,000</td>
                  <td className="td_red">- 560,000</td>
                  <td>반품처리 하지 않고 금액만 반품</td>
                </tr>
                <tr>
                  <td>2023, 05, 10</td>
                  <td>김관리103</td>
                  <td>450,000</td>
                  <td className="td_point">+ 60,000</td>
                  <td>반품처리 하지 않고 금액만 반품</td>
                </tr>
                <tr>
                  <td>2023, 05, 10</td>
                  <td>김관리103</td>
                  <td>450,000</td>
                  <td className="td_red">- 750,000</td>
                  <td>반품처리 하지 않고 금액만 반품</td>
                </tr>
              </tbody>
            </table>
            <div className="com_calendar_wrap">
              <div className="year ">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2023</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
            </div>
            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_labels">
                  <div className="chart_name">
                    <div className="chart_item">
                      <span className="chart_name_label">발송</span>
                      <div className="chart_slider chart_orange"></div>
                    </div>
                    <div className="chart_item">
                      <span className="chart_name_label">반품</span>
                      <div className="chart_slider chart_blue"></div>
                    </div>
                  </div>
                </div>
                <div className="chart_content">
                  <LineChart
                    data={lineChartDataSalesBookDetail}
                    width={lineChartWidth}
                    height={lineChartHeight}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default SalesBookDetail;
